// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

/* ANSI */
.ansi-black-fg,
.ansi-black-bg {
  color: var(--theia-terminal-ansiBlack);
}
.ansi-bright-black-fg,
.ansi-bright-black-bg {
  color: var(--theia-terminal-ansiBrightBlack);
}

.ansi-red-fg,
.ansi-red-bg {
  color: var(--theia-terminal-ansiRed);
}
.ansi-bright-red-fg,
.ansi-bright-red-bg {
  color: var(--theia-terminal-ansiBrightRed);
}

.ansi-green-fg,
.ansi-green-bg {
  color: var(--theia-terminal-ansiGreen);
}
.ansi-bright-green-fg,
.ansi-bright-green-bg {
  color: var(--theia-terminal-ansiBrightGreen);
}

.ansi-yellow-fg,
.ansi-yellow-bg {
  color: var(--theia-terminal-ansiYellow);
}
.ansi-bright-yellow-fg,
.ansi-bright-yellow-bg {
  color: var(--theia-terminal-ansiBrightYellow);
}

.ansi-blue-fg,
.ansi-blue-bg {
  color: var(--theia-terminal-ansiBlue);
}
.ansi-bright-blue-fg,
.ansi-bright-blue-bg {
  color: var(--theia-terminal-ansiBrightBlue);
}

.ansi-magenta-fg,
.ansi-magenta-bg {
  color: var(--theia-terminal-ansiMagenta);
}
.ansi-bright-magenta-fg,
.ansi-bright-magenta-bg {
  color: var(--theia-terminal-ansiBrightMagenta);
}

.ansi-cyan-fg,
.ansi-cyan-bg {
  color: var(--theia-terminal-ansiCyan);
}
.ansi-bright-cyan-fg,
.ansi-bright-cyan-bg {
  color: var(--theia-terminal-ansiBrightCyan);
}

.ansi-white-fg,
.ansi-white-bg {
  color: var(--theia-terminal-ansiWhite);
}
.ansi-bright-white-fg,
.ansi-bright-white-bg {
  color: var(--theia-terminal-ansiBrightWhite);
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@theia/core/src/browser/style/ansi.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF,SAAS;AACT;;EAEE,sCAAsC;AACxC;AACA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,sCAAsC;AACxC;AACA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,uCAAuC;AACzC;AACA;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,wCAAwC;AAC1C;AACA;;EAEE,8CAA8C;AAChD;;AAEA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,sCAAsC;AACxC;AACA;;EAEE,4CAA4C;AAC9C","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n/* ANSI */\n.ansi-black-fg,\n.ansi-black-bg {\n  color: var(--theia-terminal-ansiBlack);\n}\n.ansi-bright-black-fg,\n.ansi-bright-black-bg {\n  color: var(--theia-terminal-ansiBrightBlack);\n}\n\n.ansi-red-fg,\n.ansi-red-bg {\n  color: var(--theia-terminal-ansiRed);\n}\n.ansi-bright-red-fg,\n.ansi-bright-red-bg {\n  color: var(--theia-terminal-ansiBrightRed);\n}\n\n.ansi-green-fg,\n.ansi-green-bg {\n  color: var(--theia-terminal-ansiGreen);\n}\n.ansi-bright-green-fg,\n.ansi-bright-green-bg {\n  color: var(--theia-terminal-ansiBrightGreen);\n}\n\n.ansi-yellow-fg,\n.ansi-yellow-bg {\n  color: var(--theia-terminal-ansiYellow);\n}\n.ansi-bright-yellow-fg,\n.ansi-bright-yellow-bg {\n  color: var(--theia-terminal-ansiBrightYellow);\n}\n\n.ansi-blue-fg,\n.ansi-blue-bg {\n  color: var(--theia-terminal-ansiBlue);\n}\n.ansi-bright-blue-fg,\n.ansi-bright-blue-bg {\n  color: var(--theia-terminal-ansiBrightBlue);\n}\n\n.ansi-magenta-fg,\n.ansi-magenta-bg {\n  color: var(--theia-terminal-ansiMagenta);\n}\n.ansi-bright-magenta-fg,\n.ansi-bright-magenta-bg {\n  color: var(--theia-terminal-ansiBrightMagenta);\n}\n\n.ansi-cyan-fg,\n.ansi-cyan-bg {\n  color: var(--theia-terminal-ansiCyan);\n}\n.ansi-bright-cyan-fg,\n.ansi-bright-cyan-bg {\n  color: var(--theia-terminal-ansiBrightCyan);\n}\n\n.ansi-white-fg,\n.ansi-white-bg {\n  color: var(--theia-terminal-ansiWhite);\n}\n.ansi-bright-white-fg,\n.ansi-bright-white-bg {\n  color: var(--theia-terminal-ansiBrightWhite);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
